import React, { useState } from "react";
import styled from "styled-components";
import Event from "../../services/event";
import { toast } from "react-toastify";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const SearchBar = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
`;

const Input = styled.input`
    padding: 10px;
    width: 300px;
    margin-right: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

const Button = styled.button`
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }
`;

const Results = styled.div`
    width: 100%;
    max-width: 600px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 20px;
`;

const ResultItem = styled.div`
    padding: 10px;
    border-bottom: 1px solid #eee;

    &:last-child {
        border-bottom: none;
    }
`;

const Info = styled.p`
    margin: 5px 0;
    font-size: 14px;
`;

const NoResults = styled.p`
    text-align: center;
    color: #999;
`;

const PaymentStatus = styled.span`
    color: ${(props) => (props.status === "Paga" ? "green" : "red")};
`;

const CIMI = () => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);

    function containsOnlyDigits(str) {
        return /^\d+$/.test(str);
    }

    const handleSearch = async () => {
        let paramType = containsOnlyDigits(query) ? "document" : "email";

        try {
            const response = await Event.getPersonByDocOrEmail({ [paramType]: query });
            console.log(response);
            if (response && response.data && response.data.data && response.data.data.success) {
                setResults(response.data.data.data);
            } else {
                toast.error("Desculpe, ocorreu um erro");
            }
        } catch (error) {
            console.error("Error fetching data", error);
        }
    };

    return (
        <Container>
            <SearchBar>
                <Input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Digite o email ou documento"
                />
                <Button onClick={handleSearch}>Buscar</Button>
            </SearchBar>

            <Results>
                {results.length === 0 ? (
                    <NoResults>Nenhum resultado encontrado</NoResults>
                ) : (
                    results.map((item) => (
                        <ResultItem key={item.sale_id}>
                            <Info>Nome: {item.client_name}</Info>
                            <Info>Documento: {item.client_document}</Info>
                            <Info>Telefone: {item.client_cel}</Info>
                            <Info>
                                Status do pagamento:{" "}
                                <PaymentStatus status={item.sale_status_name}>{item.sale_status_name}</PaymentStatus>
                            </Info>
                        </ResultItem>
                    ))
                )}
            </Results>
        </Container>
    );
};

export default CIMI;
